import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { show as showIntercom } from '@intercom/messenger-js-sdk';
import { ChatIcon, HeadphoneIcon, LockIcon } from 'components/icons';
import styles from './geoBlockedModal.module.scss';

const BLOCKED_COUNTRIES = [
  { name: 'Australia', flag: '🇦🇺' },
  { name: 'Comoros', flag: '🇰🇲' },
  { name: 'France', flag: '🇫🇷' },
  { name: 'Netherlands', flag: '🇳🇱' },
  { name: 'Spain', flag: '🇪🇸' },
  { name: 'United Kingdom', flag: '🇬🇧' },
  { name: 'United States', flag: '🇺🇸' },
];

const GeoBlockedModal: React.FC = () => {
  useEffect(() => {
    const originalBodyOverflow = document.body.style.overflow;
    const originalHtmlOverflow = document.documentElement.style.overflow;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = originalBodyOverflow;
      document.documentElement.style.overflow = originalHtmlOverflow;
    };
  }, []);

  return ReactDOM.createPortal(
    <div className={styles.overlay}>
      <div className={styles.modalContent}>
        <div className={styles.iconWrapper}>
          <LockIcon />
        </div>
        <h2 className={styles.title}>Service Unavailable</h2>
        <p className={styles.description}>
          We&apos;re sorry, but our services are currently unavailable in your country due to
          licensing and regulatory restrictions. Access is restricted in the following countries:
        </p>
        <div className={styles.countries}>
          {BLOCKED_COUNTRIES.map((c) => (
            <div key={c.name} className={styles.countryBadge}>
              <span className={styles.flag}>{c.flag}</span>
              <span>{c.name}</span>
            </div>
          ))}
        </div>
        <p className={styles.description}>
          If you are using a VPN, please disable it and try again. If you need further assistance,
          feel free to contact our support team.
        </p>

        <div className={styles.actions}>
          <button
            className={styles.actionBtn}
            onClick={() => showIntercom()}
            aria-label="Open Live Chat"
            title="Live Chat"
          >
            <ChatIcon />
          </button>
          <a
            href="mailto:support@dgenta.com"
            className={styles.actionBtn}
            aria-label="Email Support"
            title="Email Support"
          >
            <HeadphoneIcon />
          </a>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default GeoBlockedModal;
